<template>
  <div :class="['pipeline_layout_main', {'has-scrolling': hasScrolling}]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PipelineLayoutTabMain",
  props: {
    hasScrolling: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.pipeline_layout_main {
  flex-grow: 1;
  margin-right: $defaultGap;

  &.has-scrolling {
    overflow-y: scroll;
    margin-right: 0;
    padding-right: $defaultGap;
  }
}
</style>
